/**
 * 2days project 참여 동의서 (MVP #29 · 약관 v1.3 제7조 · 처리방침 v1.3) — 영문본.
 * 선발 후 Pre-join 에서 받는다. 항목마다 체크박스를 따로 두고, 선택 항목은 기본값 꺼짐.
 * 문구를 바꾸면 약관·처리방침도 함께 고친다.
 *
 * 항목: key(폼 필드) · required · title · links? · facts?(라벨·값 묶음 여러 개) · bullets
 */
export const CONSENT_VERSION = 'v1.3';

export const CONSENT_ITEMS = [
  {
    key: 'consentTerms',
    required: true,
    title:
      'I am 18 or older, and I agree to the 2days project Terms of Use (including the Program Guide) and Privacy Policy',
    links: [
      { label: 'Terms of Use', href: '/2days/terms?lang=en' },
      { label: 'Program Guide', href: '/2days/guide' },
      { label: 'Privacy Policy', href: '/2days/privacy?lang=en' },
    ],
    bullets: [
      'The rules for finishing and dropping out are the same as in the Program Guide you read when you applied.',
    ],
  },
  {
    key: 'consentDataUse',
    required: true,
    title: 'I agree to the collection and use of my work records and their use in my report',
    facts: [
      [
        [
          'What we collect',
          'Your working hours, tools and stack, tasks you accepted or declined and your reasons, expected submission times and their change history, check-in content and attendance (on time, late, missed), deliverables (links, files, descriptions, versions), types of tools used (detected automatically from your links), records of viewing, approving, returning for changes, and reopening work, checklist results, comments, blocker and contributor records, records of task requests you did not answer, delay types, whether you checked notifications, and the time of each action',
        ],
        [
          'Why',
          'To run the project, check deadlines, write your personal report, and issue your completion certificate',
        ],
        [
          'How long we keep it',
          '3 years after the project ends, or until you delete your account, whichever comes first (some items, such as your completion certificate, follow Section 3 of the Privacy Policy)',
        ],
      ],
    ],
    bullets: [
      'All records are saved with server time. You cannot edit or delete them during the project.',
      'Your whole team can see your comments and deliverables.',
      'Other teams in the same project can also see the following on the dashboard: team progress, each person’s tasks in progress, remaining working hours, offline status, and delayed handoffs.',
      'You can refuse to agree. However, the Program runs on these records, so you cannot take part if you do not agree.',
    ],
  },
  {
    key: 'consentPeerReview',
    required: true,
    title: 'I agree to give and receive peer reviews',
    bullets: [
      'When the project ends, you review your teammates, and they review you.',
      'Individual answers to “Would you work with this person again?” are not shown. They are shown only as anonymous totals.',
      'Written comments (praise, suggestions for improvement, and thanks) are sent to the person reviewed, without the writer’s name.',
      'However, teams are small, so the person may sometimes be able to guess who wrote a comment.',
      'You must submit peer reviews to finish the Program. If you do not agree, you cannot take part.',
    ],
  },
  {
    key: 'consentOverseasTransfer',
    required: true,
    title: 'I agree to the transfer of my personal data outside Korea to help write my report',
    facts: [
      [
        [
          'Recipient (contact)',
          'Anthropic, PBC (Claude API) · 548 Market St, PMB 90375, San Francisco, CA 94104, USA',
        ],
        ['Country', 'United States'],
        [
          'What we send',
          'Work records, comments, check-ins, and peer review content (we remove your name, email, and other direct identifiers first)',
        ],
        ['Why', 'To help draft your report'],
        [
          'How and when',
          'When we write reports after the project ends. Sent only through the Claude API over an encrypted network.',
        ],
        [
          'How long they keep it',
          'Based on the API terms (as a rule, deleted within 30 days; there are exceptions, such as reviews of policy violations or storage required by law)',
        ],
      ],
    ],
    bullets: [
      'Under the API terms, Anthropic does not use this data to train its AI models.',
      'You can refuse to agree by emailing contact@ko-ready.com. However, we need this transfer to write your report, so you cannot take part if you do not agree.',
    ],
  },
  {
    key: 'consentPromoUse',
    required: false,
    title: 'I agree to the promotional use of my deliverables and review',
    facts: [
      [
        [
          'What we use',
          'Your deliverables, what you did in the project and your results (for example, your role, the tasks you worked on, and their results), and your review of the Program',
        ],
        [
          'Why',
          'To make participant reviews and content that promotes our service (website, social media, promotional materials, and similar)',
        ],
        ['How long we keep it', 'Until you withdraw your consent'],
      ],
      [
        [
          'Shown with your review',
          'Your name, nationality, role, and the photo on your Koready profile',
        ],
        ['How long we keep it', 'Until you withdraw your consent'],
      ],
    ],
    bullets: [
      'If you made a deliverable with other participants, we use it only if every participant who contributed agrees.',
      'If the content includes the name or comments of a participant who did not agree, we edit it so they cannot be recognized.',
      'If you do not agree, you can still take part.',
      'If you withdraw, we will not make or post new content that includes you. We will also promptly delete content already posted on channels we manage, or edit it so you cannot be recognized.',
    ],
  },
  {
    key: 'consentRealName',
    required: false,
    title: 'I agree to have my real name shown',
    bullets: [
      'We show your real name on your teammates’ screens and the dashboard. If you do not agree, we show a nickname you choose instead. You can change the nickname later in Profile.',
      'Your completion certificate is for submitting to companies, so it always shows your real name, even if you do not agree here. The certificate check page shows your real name, project name, role, participation dates, contribution, and issue date. You decide who to share the link with.',
    ],
  },
  {
    key: 'consentSelfCheckLink',
    required: false,
    title: 'I agree to link my 3-minute self-check results',
    bullets: [
      'We use the results of the 3-minute self-check you took earlier on Koready in the “Self-awareness comparison” part of your report.',
      'If you do not agree, only this part is left out of your report. It does not affect your participation.',
    ],
  },
];
